package com.shadowings.gero.data.datasource

import androidx.datastore.preferences.core.booleanPreferencesKey
import androidx.datastore.preferences.core.intPreferencesKey
import androidx.datastore.preferences.core.longPreferencesKey
import androidx.datastore.preferences.core.stringPreferencesKey

object DataStoreKeys {
    // Chiavi a valore fisso
    val EXPERIENCE_TOTAL = intPreferencesKey("experience_total")
    val HEARTS = intPreferencesKey("hearts")
    val CONSUMABLES_UPDATED_AT = longPreferencesKey("consumables_updated_at")
    val LAST_MODIFIED = longPreferencesKey("last_modified")
    val TEST_MODE = booleanPreferencesKey("test_mode")
    val TUTORIAL_DONE = intPreferencesKey("tutorial_done")
    val STARS_BONUS = intPreferencesKey("stars___bonus")
    val LAST_OPEN_DATE = intPreferencesKey("last_open_date")
    val STRIKE = intPreferencesKey("strike")
    val LAST_QUIZ_DATE = intPreferencesKey("last_quiz_date")
    val COMPLETED_QUIZ_DATES = stringPreferencesKey("completed_quiz_dates")
    val REMINDER_ENABLED = booleanPreferencesKey("reminder_enabled")
    val REMINDER_HOUR = intPreferencesKey("reminder_hour")
    val REMINDER_MINUTE = intPreferencesKey("reminder_minute")
    val SHOW_CHEATS = booleanPreferencesKey("show_cheats")
    val APP_LANGUAGE = stringPreferencesKey("app_language")
    val THEME_MODE = stringPreferencesKey("theme_mode")
    val SOUND_ENABLED = booleanPreferencesKey("sound_enabled")
    val HAPTIC_ENABLED = booleanPreferencesKey("haptic_enabled")
    val HIDE_OPTIONS = booleanPreferencesKey("hide_options")
    val WALKTHROUGH_DONE = booleanPreferencesKey("walkthrough_done")
    val COMPENDIO_WALKTHROUGH_DONE = booleanPreferencesKey("compendio_walkthrough_done")
    val BUILDER_WALKTHROUGH_DONE = booleanPreferencesKey("builder_walkthrough_done")
    val CHARACTERS_WALKTHROUGH_DONE = booleanPreferencesKey("characters_walkthrough_done")
    val PROFILE_WALKTHROUGH_DONE = booleanPreferencesKey("profile_walkthrough_done")
    val LAST_SEEN_CHANGELOG_VERSION = stringPreferencesKey("last_seen_changelog_version")
    val SAVED_BUILDER_WORDS = stringPreferencesKey("saved_builder_words")
    val REVIEW_PROMPT_DONE = booleanPreferencesKey("review_prompt_done")
    val IS_FULL_VERSION_UNLOCKED = booleanPreferencesKey("is_full_version_unlocked")
    val CALENDAR_PROMPT_DONE = booleanPreferencesKey("calendar_prompt_done")
    val CALENDAR_PROMPT_DISMISSED_AT = longPreferencesKey("calendar_prompt_dismissed_at")
    val STREAK_RESTORATION_TOKENS = stringPreferencesKey("streak_restoration_tokens")
    val STREAK_RESTORATION_BACKFILL_DONE = booleanPreferencesKey("streak_restoration_backfill_done")
    val STREAK_RESTORATION_BADGE_SEEN = booleanPreferencesKey("streak_restoration_badge_seen")
    val ANSWERED_FEATURE_POLLS = stringPreferencesKey("answered_feature_polls")
    val WRONG_ANSWERS = stringPreferencesKey("wrong_answers")
    val WRONG_ANSWERS_UPDATED_AT = longPreferencesKey("wrong_answers_updated_at")
    val FAVORITE_HIEROS_UPDATED_AT = longPreferencesKey("favorite_hieros_updated_at")
    val FAVORITE_WORDS_UPDATED_AT = longPreferencesKey("favorite_words_updated_at")

    // Chiavi a prefisso dinamico (prefissi come costanti stringa)
    const val PREFIX_STARS = "stars_"
    const val PREFIX_PERFECT = "perfect_"
    const val PREFIX_EXPLANATIONS = "explanations_"
    const val PREFIX_ALYN_COLOR = "alynColor_"
    const val PREFIX_NILO_COLOR = "niloColor_"
    const val PREFIX_ZETA_COLOR = "zetaColor_"
    const val PREFIX_MASKO_COLOR = "maskoColor_"
    const val PREFIX_FAVORITE_HIERO = "favHiero_"
    const val PREFIX_FAVORITE_WORD = "favWord_"

    fun starsKey(id: String) = intPreferencesKey("$PREFIX_STARS$id")
    fun perfectKey(id: String) = intPreferencesKey("$PREFIX_PERFECT$id")
    fun explanationsKey(lessonId: String) = intPreferencesKey("$PREFIX_EXPLANATIONS$lessonId")
    fun alynColorKey(categoryKey: String) = intPreferencesKey("$PREFIX_ALYN_COLOR$categoryKey")
    fun niloColorKey(categoryKey: String) = intPreferencesKey("$PREFIX_NILO_COLOR$categoryKey")
    fun zetaColorKey(categoryKey: String) = intPreferencesKey("$PREFIX_ZETA_COLOR$categoryKey")
    fun maskoColorKey(categoryKey: String) = intPreferencesKey("$PREFIX_MASKO_COLOR$categoryKey")
    fun favoriteHieroKey(code: String) = intPreferencesKey("$PREFIX_FAVORITE_HIERO$code")
    fun favoriteWordKey(id: String) = intPreferencesKey("$PREFIX_FAVORITE_WORD$id")
}
